export const BOT_TYPES = {
  AUTO_NOTIFICATION_BOT: 'TIME_BASED',
  TIP_RESPONSE_BOT: 'TIP',
  WELCOME_BOT: 'WELLCOME',
};
